module.exports = __webpack_public_path__ + "img/9.b296b849.png";